/**
 * @author taoWu
 * @description 身份验证审核及查看页面
 * @Date 2022/10/12
 */
import React from 'react';
import {connect} from 'dva';
import {PhotoProvider, PhotoView} from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import {component_tool, framework_tool, utils_tool} from '@/tool'
import moment from "moment";

let {WizContainer, WizReduxTemplate, modelUtils} = framework_tool;
let { WizCard, WizButton, WizInput, WizSpin, WizCol, WizRow,WizTag, WizModal, WizList, WizCommonSteps, WizAvatar, WizIcon,WizTypography} = component_tool;
const {TextArea} = WizInput;
const { Title } = WizTypography;
let {checkStrLength, Session} = utils_tool;

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}
const formatterMinute = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
const formatterExamType = (val) => {
  let newVal;
  switch (val) {
    case 0 :
      newVal = '独立考试'
      break;
    case 1 :
      newVal = '课程考试'
      break;
    case 3 :
      newVal = ''
      break;
  }
  return newVal;
}
const formatterStatus = (val) => {
  let newVal;
  switch (val) {
    case  0 :
      newVal = '待验证'
      break;
    case  1 :
      newVal = '已通过'
      break;
    case  2 :
      newVal = '未通过'
      break;
    case  3 :
      newVal = '未通过-非活体'
    break;
    default :
      newVal = '';
  }
  return newVal;
}
const formatterExamPersonAuthStatus = (val) => {
  let newVal;
  switch (val) {
    case 0 :
      newVal = '考试进行中'
      break;
    case 1 :
      newVal = '系统审核通过'
      break;
    case 2 :
      newVal = '待审核'
      break;
    case 3 :
      newVal = '审核通过'
      break;
    case 4 :
      newVal = '审核未通过'
      break;
    case 5 :
      newVal = '未认证'
      break;
  }
  return newVal;
}
const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    //查看
    if (history.location.pathname === '/online/examRecord/examPersonAuthLook') {
      if (history.location && history.location.record) {
        record = history.location.record
        record.operationMode = 'look'
        Session.set('examPersonAuthDetailInfo', record)
      } else {
        record = Session.get('examPersonAuthDetailInfo') || {}
      }
    } else if (history.location.pathname === '/online/examRecord/examPersonAuthAudit') {
      //审核 1
      if (history.location && history.location.record) {
        record = history.location.record
        //指定审核
        record.operationMode = 'alone'
        Session.set('examPersonAuthDetailInfo', record)
      } else {
        record = Session.get('examPersonAuthDetailInfo') || {}
      }
    } else if (history.location.pathname === '/online/examRecord/examRecordAuthAudit') {
      //审核 2
      if (history.location && history.location.record) {
        record = history.location.record
        //顺序拿取数据审核
        record.operationMode = 'order'
        record.examId = record.id;
        Session.set('examRecordAuthAuditInfo', record)
      } else {
        record = Session.get('examRecordAuthAuditInfo') || {}
      }
    }
  }
  return record
}

class ExamPersonAuthDetail extends WizContainer {

  componentName = 'ExamPersonAuthDetail';

  constructor(props) {
    super(props);
    const {history} = props;
    let record = getParamRecord(history)
    const {examId, operationMode} = record;
    this.defaultState = {
      operationMode,//'look'查看,'alone' 直接审核 order 顺序审核
      record: record,//传过来的记录
      examId,
      text: '',//审核意见
      nextAuditLimitNum: 0
    }
    this.state = {
      personAuthLogId: null,
      reverse: false,
      time: undefined,
      examId,
      operationMode,
      nextAuditLimitNum: 0,
      status: 2,
      imgList: [],
      logList: [],
      examPersonAuthDetailInfo: {
        personAuthLogId: null,
        surplusAuditCount: null,
        approvedCount: null,
        personInfo: null,
        examPersonAuth: null,
        exam: null,
        logList: null,
      },
    }
    this.initialValue = record;
  }

  _componentDidMount() {
    if (this.initialValue.operationMode && (this.initialValue.operationMode === 'look' || this.initialValue.operationMode === 'alone')) {
      this.getExamPersonAuthDetailInfo({id: this.initialValue.id, examId: this.initialValue.examId,})
    } else if (this.initialValue.operationMode && this.initialValue.operationMode === 'order') {
      this.getExamPersonAuthDetailInfo({
        examId: this.initialValue.examId,
        status: this.state.status,
        nextAuditLimitNum: 0
      })
    }
  }

  propsAndStateOnChange = {
    examPersonAuthDetail: this._getExamPersonAuthDetailOver.bind(this),
    auditExamPersonAuth: this._getAuditExamPersonAuthOver.bind(this),
  }

  /**
   * 审核保存返回
   * @param nextProps
   * @param nextState
   * @returns {boolean}
   * @private
   */
  _getAuditExamPersonAuthOver(nextProps, nextState) {
    const {operationMode} = nextState;
    if (nextProps.auditExamPersonAuth.code == 1) {
      if (operationMode==='look'){
        wizNotice.success("操作成功");
      }else if (operationMode==='order' || operationMode==='alone'){
        let examPersonAuthDetailInfo = nextProps.auditExamPersonAuth.data;
        if (examPersonAuthDetailInfo && (examPersonAuthDetailInfo.personAuthLogId!=null && examPersonAuthDetailInfo.personAuthLogId!=-1 &&
          examPersonAuthDetailInfo.personAuthLogId !=undefined && examPersonAuthDetailInfo.personAuthLogId!= '')){
          wizNotice.success("操作成功");
          const {personInfo, logList,roundTimesLogList,examPersonAuth} = examPersonAuthDetailInfo;
          if (personInfo != null) {
            let imgList = [];
            imgList.push({img: personInfo.faceImg1, name: '头像照片'});
            imgList.push({img: personInfo.faceImg2, name: '身份证照片'});
            // imgList.push({img: personInfo.faceImg3, name: '手持身份证照'});
            nextState.imgList = imgList;
          }else {
            let imgList = [];
            imgList.push({img: '', name: '头像照片'});
            imgList.push({img: '', name: '身份证照片'});
            // imgList.push({img: personInfo.faceImg3, name: '手持身份证照'});
            nextState.imgList = imgList;
          }
          let logListNew = [];
          let log = {total: 0, failCount: 0, type: 'first', id: 'first'};
          if (examPersonAuth ) {
            const {faceCurrentTimes,roundTimes} = examPersonAuth;
            log.total = faceCurrentTimes;
            log.failCount = roundTimes;
          }
          logListNew.push(log);
          if (roundTimesLogList && roundTimesLogList instanceof Array && roundTimesLogList.length > 0) {
            roundTimesLogList.forEach(e => {
              logListNew.push(e);
            });
          }
          nextState.logList = logListNew;
          nextState.personAuthLogId = examPersonAuthDetailInfo.personAuthLogId
          nextState.examPersonAuthDetailInfo = examPersonAuthDetailInfo;
          nextState.time = new Date().getTime();
        }else {
          WizModal.warning({
            title: '注意',
            content:'暂无待审核数据，点击“确认”返回列表页面',
            okText:"确认",
            onOk: () => {
              if (operationMode==='order'){
                this.jumpPage('replace', '/online/examRecord');
              }else {
                this.jumpPage('replace', '/online/examRecord/examPersonAuth');
              }
            },
            onCancel: () => {
              if (operationMode==='order'){
                this.jumpPage('replace', '/online/examRecord');
              }else {
                this.jumpPage('replace', '/online/examRecord/examPersonAuth');
              }
            },
          })
        }
      }else {
        nextState.operationMode = 'look';
      }
    } else {
      let msg = nextProps.auditExamPersonAuth.msg;
      if (operationMode==='order' || operationMode==='alone'){
        if (msg==='数据不存在'){
          WizModal.warning({
            title: '注意',
            content:'暂无待审核数据，点击“确认”返回列表页面',
            okText:"确认",
            onOk: () => {
              if (operationMode==='order'){
                this.jumpPage('replace', '/online/examRecord');
              }else {
                this.jumpPage('replace', '/online/examRecord/examPersonAuth');
              }
            },
            onCancel: () => {
              if (operationMode==='order'){
                this.jumpPage('replace', '/online/examRecord');
              }else {
                this.jumpPage('replace', '/online/examRecord/examPersonAuth');
              }
            },
          })
        }else if (msg === '当前记录审核状态不为待审核，请刷新检查'){
          WizModal.warning({
            title: '注意',
            content:'此考试记录的身份验证信息已审核，无需重复审核，点击“确认”进入下一条待审核数据',
            okText:"确认",
            onOk: () => {
              this.getExamPersonAuthDetailInfo({
                nextAuditLimitNum: nextState.nextAuditLimitNum,
                examId: nextState.examId,
                status: nextState.status
              })
            },
            onCancel: () => {
              this.getExamPersonAuthDetailInfo({
                nextAuditLimitNum: nextState.nextAuditLimitNum,
                examId: nextState.examId,
                status: nextState.status
              })
            },
          })
        }else if (msg === '试卷结果更新失败，审核失败' || msg === '审核失败，请联系管理员' || msg === '考试不存在，审核失败' ||
          msg === '当前审核状态错误' || msg === '审核记录ID不能为空' || msg === '请先登录'){
          wizNotice.error(msg);
        }else {
          wizNotice.error(msg);
        }
      }else {
        wizNotice.error(msg);
      }
    }
    return true;
  }

  /**
   * 解析认证信息
   * @param nextProps
   * @param nextState
   * @returns {boolean}
   * @private
   */
  _getExamPersonAuthDetailOver(nextProps, nextState) {
    const {operationMode} = nextState;
    if (nextProps.examPersonAuthDetail.code == 1) {
      let examPersonAuthDetailInfo = nextProps.examPersonAuthDetail.data;
      const {personInfo, logList,roundTimesLogList,examPersonAuth} = examPersonAuthDetailInfo;
      if (personInfo != null) {
        let imgList = [];
        imgList.push({img: personInfo.faceImg1, name: '头像照片'});
        imgList.push({img: personInfo.faceImg2, name: '身份证照片'});
        // imgList.push({img: personInfo.faceImg3, name: '手持身份证照'});
        nextState.imgList = imgList;
      }else {
        let imgList = [];
        imgList.push({img: '', name: '头像照片'});
        imgList.push({img: '', name: '身份证照片'});
        // imgList.push({img: personInfo.faceImg3, name: '手持身份证照'});
        nextState.imgList = imgList;
      }
      let logListNew = [];
      let log = {total: 0, failCount: 0, type: 'first', id: 'first'};
      if (examPersonAuth ) {
        const {faceCurrentTimes,roundTimes} = examPersonAuth;
        log.total = faceCurrentTimes;
        log.failCount = roundTimes;
      }
      logListNew.push(log);
      if (roundTimesLogList && roundTimesLogList instanceof Array && roundTimesLogList.length > 0) {
        roundTimesLogList.forEach(e => {
          logListNew.push(e);
        });
      }
      nextState.logList = logListNew;
      nextState.personAuthLogId = examPersonAuthDetailInfo.personAuthLogId
      nextState.examPersonAuthDetailInfo = examPersonAuthDetailInfo;
      nextState.time = new Date().getTime();
    } else {
      let msg = nextProps.examPersonAuthDetail.msg;
      if (operationMode==='order' || operationMode==='alone') {
        if (msg==='数据不存在'){
          WizModal.warning({
            title: '注意',
            content:'暂无待审核数据，点击“确认”返回列表页面',
            okText:"确认",
            onOk: () => {
              if (operationMode==='order'){
                this.jumpPage('replace', '/online/examRecord');
              }else {
                this.jumpPage('replace', '/online/examRecord/examPersonAuth');
              }
            },
            onCancel: () => {
              if (operationMode==='order'){
                this.jumpPage('replace', '/online/examRecord');
              }else {
                this.jumpPage('replace', '/online/examRecord/examPersonAuth');
              }
            },
          })
        }else {
          wizNotice.error(nextProps.examPersonAuthDetail.msg || '获取数据失败，请稍后再试');
        }
      }else {
        wizNotice.error(nextProps.examPersonAuthDetail.msg || '获取数据失败，请稍后再试');
      }
    }
    return true;
  }

  /**
   * 下一个
   */
  _next = () => {
    this.setState({...this.defaultState, nextAuditLimitNum: ++this.state.nextAuditLimitNum}, () => {
      this.getExamPersonAuthDetailInfo({
        nextAuditLimitNum: this.state.nextAuditLimitNum,
        examId: this.state.examId,
        status: this.state.status
      })
    })
  }


  /**
   * 审核
   */
  auditExamPersonAuth = (status) => {
    let {personAuthLogId, examId, text} = this.state;
    let { operationMode } = this.defaultState;
    let nextAuditLimitNum = null;
    if (operationMode==='order' || operationMode==='alone'){
      nextAuditLimitNum = this.state.nextAuditLimitNum;
    }
    if (status===4){
      WizModal.confirm({
        title: '注意',
        content:'您当前审核的学员人脸认证信息为“不通过”，是否确认？',
        onOk: () => {
          this.doAction({
            path: 'examPersonAuth/auditResult',
            payload: {
              key: 'examPersonAuth@auditResult',
              apiParams: {
                id: personAuthLogId,
                status,
                examId,
                nextAuditLimitNum: nextAuditLimitNum,
                auditInfo: text
              }
            }
          })
        },
        onCancel() {
        }
      })
    }else {
      this.doAction({
        path: 'examPersonAuth/auditResult',
        payload: {
          key: 'examPersonAuth@auditResult',
          apiParams: {
            id: personAuthLogId,
            status,
            examId,
            nextAuditLimitNum: nextAuditLimitNum,
            auditInfo: text
          }
        }
      })
    }
  }

  /**
   * 获取人员认证信息
   */
  getExamPersonAuthDetailInfo = (apiParams = {}) => {
    this.doAction({
      path: 'examPersonAuth/selectOneInfo',
      payload: {
        key: "examPersonAuth@selectOneInfo",
        apiParams
      }
    })
  }

  /**
   * 图片信息加载
   *
   * @param img
   * @param imgName
   * @returns {JSX.Element}
   * @private
   */
  _getImgInfo(img, imgName) {
    let unImgStr = '暂未采集';
    return (
      <>
        <div style={{textAlign: 'center', margin: 'auto'}}>
          <div style={{display: 'flex', justifyContent: 'flex-start', textAlign: 'center'}}>
            { img!=null && img!='' && img!=undefined ?
              (<PhotoProvider
                toolbarRender={({onScale, scale}) => {
                  return (
                    <>
                      <svg className="PhotoView-Slider__toolbarIcon" onClick={() => onScale(scale + 1)}/>
                      <svg className="PhotoView-Slider__toolbarIcon" onClick={() => onScale(scale - 1)}/>
                    </>
                  );
                }}>
                <div className="foo">
                  <PhotoView key={'face_auth_img_' + 1 + '_' + img} src={getOssFilePath(img)}>
                    <img style={{justifyContent: 'center', alignItems: 'center', margin: 'auto', display: 'block'}}
                         height={200} width={200} src={getOssFilePath(img)} alt=""/>
                  </PhotoView>
                </div>
              </PhotoProvider>) :
              (<div className="foo" >
                <div style={{
                  height: 200,
                  width: 200,
                  overflow: 'hidden',
                  position: 'relative',
                  padding: 50,
                  textAlign: 'center',
                }}>
                  <Title level={4} style={{color:'#108ee9'}}>{unImgStr}</Title>
                </div>
              </div>)
            }
          </div>
          {
            imgName ?
              (<div style={{textAlign: 'center', width: 200, paddingTop: 10}}>
                {imgName}
              </div>) : null
          }
        </div>
      </>)
  }

  /**
   * 考试基本信息
   * @param exam
   * @returns {JSX.Element}
   * @private
   */
  _showExamInfo(exam) {
    let content = <WizCard title={'基本信息'} bodyStyle={{paddingLeft: 20, paddingBottom: 25, paddingTop: 25}}>
      <WizRow>
        <WizCol span={2} offset={1} style={{textAlign: 'right'}}>考试名称： </WizCol>
        <WizCol span={6} style={{textAlign: 'left'}}>{exam && exam.title}</WizCol>
        <WizCol span={2} style={{textAlign: 'right'}}>考试类型： </WizCol>
        <WizCol span={4} style={{textAlign: 'left'}}>{exam && formatterExamType(exam.examType)}</WizCol>
        <WizCol span={3} style={{textAlign: 'right'}}>考试分类： </WizCol>
        <WizCol span={6} style={{textAlign: 'left'}}>{exam && exam.categoryType}</WizCol>
      </WizRow>
      <WizRow style={{marginTop: 20}}>
        <WizCol span={2} offset={1} style={{textAlign: 'right'}}>考试时间： </WizCol>
        <WizCol span={6}
                style={{textAlign: 'left'}}>{exam && formatterMinute(exam.startDate) + ' - ' + formatterMinute(exam.endDate)}</WizCol>
        <WizCol span={2} style={{textAlign: 'right'}}>考试时长： </WizCol>
        <WizCol span={4}
                style={{textAlign: 'left'}}>{exam && (exam.limitMinutes != null ? exam.limitMinutes + '分钟' : '')}</WizCol>
        <WizCol span={3} style={{textAlign: 'right'}}>通过分数/总分： </WizCol>
        <WizCol span={6} style={{textAlign: 'left'}}>{exam && (exam.passScore + '/' + exam.totalScore)}</WizCol>
      </WizRow>
    </WizCard>
    return content;
  }

  /**
   * 人员基本信息
   * @param personInfo
   * @returns {JSX.Element}
   * @private
   */
  _showPersonBaseInfo(personInfo) {
    let imgList = [];
    personInfo && imgList.push(personInfo);
    let content = <WizCard title={'人员基本信息'} bodyStyle={{paddingLeft: 20, paddingBottom: 25, paddingTop: 25}}>
      <WizRow>
        <WizCol span={2} offset={1} style={{textAlign: 'right'}}>学员姓名： </WizCol>
        <WizCol span={6} style={{textAlign: 'left'}}>{personInfo && personInfo.fullName}</WizCol>
        <WizCol span={2} style={{textAlign: 'right'}}>学员账号： </WizCol>
        <WizCol span={4} style={{textAlign: 'left'}}>{personInfo && personInfo.userName}</WizCol>
        <WizCol span={3} style={{textAlign: 'right'}}>手机号： </WizCol>
        <WizCol span={6} style={{textAlign: 'left'}}>{personInfo && personInfo.mobile}</WizCol>
      </WizRow>
      <WizRow style={{marginTop: 20}}>
        <WizCol span={2} offset={1} style={{textAlign: 'right'}}>身份证号： </WizCol>
        <WizCol style={{textAlign: 'left'}}>{personInfo && personInfo.idCard}</WizCol>
      </WizRow>
      <WizRow style={{marginTop: 20}}>
        <WizCol span={2} offset={1} style={{textAlign: 'right'}}>实名认证照片： </WizCol>
        <WizCol span={21} style={{textAlign: 'left'}}>
          {this.state.imgList.length > 0 ? this._showPersonImgTable() : ''}
        </WizCol>
      </WizRow>
    </WizCard>
    return content;
  }

  /**
   * 人脸图片
   * @returns {JSX.Element}
   * @private
   */
  _showPersonImgTable() {
    return <WizList grid={{gutter: 16, column: 4}}
                    bordered={false}
                    dataSource={this.state.imgList}
                    renderItem={item => (
                      <WizList.Item>
                        {this._getImgInfo(item.img, item.name)}
                      </WizList.Item>
                    )}
    />
  }


  _showExamPersonAuthLog() {
    let stepsProps = {
      style: {paddingTop: 50},
      pending: false,
      reverse: this.state.reverse,
    };
    let stepProps = {};
    let cardProps = {
      title: '',
      icon: '',
    };
    // datas=logList
    let renderItem = (data, index, datas, callback) => {
      const {total, failCount, type, id, authenticationType} = data;
      let heightStyle = '250px';
      //type: 'first'  验证类型{0:考前认证,1:考中认证}
      let typeStr = '';
      if ((index + 1) === this.state.logList.length) {
        heightStyle = '250px';
      }
      if (type != null && type === 'first') {
        heightStyle = '120px';
      }
      let icon = 'clock-circle';
      let color = '#e5e5e5';
      if (authenticationType != null && authenticationType === 0) {
        icon = 'contacts';
        color = '#3C8DBC';
        typeStr = '考前认证';
      } else if (authenticationType != null && authenticationType === 1) {
        icon = 'contacts';
        color = '#87d068';
        typeStr = '考中认证';
      }
      callback({
        key: id + '_renderItem_'+this.state.time,
        color: color,
        dot: <> {typeStr === '' ? null :
          <span style={{marginRight: 20}}><font style={{'color': 'black'}}>{typeStr}</font></span>}
          <WizAvatar size="small"
                     style={{
                       marginRight: typeStr === '' ? null : 75,
                       color: '#FFFFFF',
                       backgroundColor: color,
                       textAlign: 'center',
                       verticalAlign: 'middle',
                     }}
                     icon={icon}
          />
        </>
      });
      return this._getRenderItem(data, heightStyle)
    };

    let content =
      <WizCard title={'人员识别信息'} bodyStyle={{paddingLeft: 100, paddingBottom: 25, paddingTop: 25}}>
        <WizCommonSteps
          timelineProps={stepsProps}
          itemProps={stepProps}
          cardProps={cardProps}
          datas={this.state.logList}
          renderItem={renderItem}
          otherTopCardProps={null}
        />
      </WizCard>
    return content;
  }

  /**
   * 获取身份验证信息渲染内容
   */
  _getRenderItem = (examPersonAuthLog, heightStyle) => {
    //type: 'first'  验证类型{0:考前认证,1:考中认证}
    const {total, failCount, type, id, authenticationType, img,certImg, authenticationTime, authenticationStatus} = examPersonAuthLog;
    let content;
    let top = -94;
    if (type != null && type === 'first') {
      top = 0;
      content =
        <div style={{marginLeft: 30, padding: 0, alignItems: 'center', justifyContent: 'left', textAlign: 'left'}}>
          {'学员共认证 '}<font style={{'color': 'black'}}><strong>{total}</strong></font>{' 次，未通过 '}
          <font style={{'color': 'red'}}><strong>{failCount}</strong></font>{' 次'}
        </div>
    } else {
      content =
        <WizCard bordered={false}
                 bodyStyle={{height: 220, padding: 0}}
                 style={{marginLeft: 30, paddingTop: 20, paddingBottom: 0, paddingLeft: 15, background: '#eceaea'}}>
          <div>
            <div style={{
              width: '25%',
              float: 'left', position: 'relative',
              textAlign: 'center', verticalAlign: 'center'
            }}>
              {this._getImgInfo(img, null)}
            </div>
            <div style={{
              width: '25%',
              float: 'left', position: 'relative',
              textAlign: 'center', verticalAlign: 'center'
            }}>
              {this._getImgInfo(certImg, null)}
            </div>
            <div style={{width: '50%', float: 'left', position: 'relative'}}>
              <WizRow style={{marginTop: 20}}>
                <WizCol span={4} offset={1} style={{textAlign: 'right'}}>验证时间： </WizCol>
                <WizCol span={13}
                        style={{textAlign: 'left'}}>{formatterMinute(authenticationTime)}</WizCol>
              </WizRow>
              <WizRow style={{marginTop: 20}}>
                <WizCol span={4} offset={1} style={{textAlign: 'right'}}>验证结果： </WizCol>
                <WizCol span={13} style={{textAlign: 'left'}}>{formatterStatus(authenticationStatus)}</WizCol>
              </WizRow>
            </div>
          </div>
        </WizCard>
    }
    return (
      <div
        style={{
          height: heightStyle,
          position: 'relative',
          top: top,
          marginLeft: 10
        }}
      >
        {content}
      </div>
    )
  };


  /**
   * 审核信息
   */
  _examPersonAuthVerify() {
    const {examPersonAuthDetailInfo, operationMode, personAuthLogId, nextAuditLimitNum} = this.state;
    const {surplusAuditCount, approvedCount, examPersonAuth} = examPersonAuthDetailInfo;
    let {examPersonAuthLoading} = this.props;
    //operationMode,//'look'查看,'alone' 直接审核 order 顺序审核
    let btns = operationMode === 'look' ? <></> : (
      <div>
        <div className='form-btns' style={{width: '20%', float: 'left', marginLeft: 0, textAlign: 'left'}}>
          <WizButton type='primary'
                     disabled={!examPersonAuthDetailInfo || (!personAuthLogId && personAuthLogId !== 0) || examPersonAuthLoading}
                     onClick={() => {
                       this.auditExamPersonAuth(3)
                     }}>通过</WizButton>
          <WizButton type='danger'
                     disabled={!examPersonAuthDetailInfo || (!personAuthLogId && personAuthLogId !== 0) || examPersonAuthLoading}
                     onClick={() => {
                       this.auditExamPersonAuth(4)
                     }}>不通过</WizButton>
          {nextAuditLimitNum + 1 < surplusAuditCount ? <WizButton onClick={() => {
            this._next()
          }}>下一个</WizButton> : <></>}
        </div>
        <div style={{width: '80%', float: 'left'}}>
          <WizRow style={{marginTop: 10}}>
            <WizCol style={{textAlign: 'right'}}>
              <font style={{'color': 'red'}}> {'本考试还剩余 ' + surplusAuditCount + ' 条待审批，'}</font>
              {'已审批 ' + approvedCount + ' 条。'}</WizCol>
          </WizRow>
        </div>
      </div>
    )
    let result = operationMode === 'look' ? (
      <div className='verify' style={{ marginTop:25,marginBottom:25}}>
        <div className='text'>
          <WizRow>
            <WizCol span={2} style={{textAlign: 'right'}}>审核结果：</WizCol>
            <WizCol span={20} style={{textAlign: 'left'}}>{examPersonAuth && formatterExamPersonAuthStatus(examPersonAuth.status)}</WizCol>
          </WizRow>
        </div>
      </div>
    ) : <></>
    let textarea = operationMode === 'look' ?
      (
        <div className='verify' style={{ marginTop:25,marginBottom:50}}>
          <div className='text'>
            <WizRow>
              <WizCol span={2} style={{textAlign: 'right'}}>审核意见：</WizCol>
              <WizCol span={20} style={{textAlign: 'left'}}>{examPersonAuth && examPersonAuth.auditInfo}</WizCol>
            </WizRow>
          </div>
        </div>
      ) : (
        <TextArea value={this.state.text}
                  maxLength={50} rows={4}
                  placeholder="请输入审核意见"
                  onChange={(e) => {
                    this.setState({text: e.target.value})
                  }}/>
      )
    return (
      <WizCard title='审核' icon={'audit'}>
        {result}
        <div className='verify'>
          <div className='verify-content'>
            {textarea}
            {btns}
          </div>
        </div>
      </WizCard>
    )
  }

  _render() {
    let record = this.initialValue;
    let {examPersonAuthDetailInfo, operationMode} = this.state;
    let {examPersonAuthLoading} = this.props;
    const {
      personAuthLogId,
      surplusAuditCount,
      approvedCount,
      personInfo,
      examPersonAuth,
      exam,
      logList,
    } = examPersonAuthDetailInfo;
    return <>
      <WizSpin tip={'加载中'} spinning={examPersonAuthLoading}>
        <div>
          <WizCard key= {this.state.time} >
          {this._showExamInfo(exam)}
          {this._showPersonBaseInfo(personInfo)}
          {this._showExamPersonAuthLog()}
          {/*{operationMode === 'look' ? null : this._examPersonAuthVerify()}*/}
          {this._examPersonAuthVerify()}
          </WizCard>
        </div>
      </WizSpin>
    </>
  }
}

const mapStateToProps = (state, ownProps) => {
  const {examPersonAuth} = state;
  const examPersonAuthDetail = modelUtils.getModelEntity(examPersonAuth, "examPersonAuth@selectOneInfo");
  const auditExamPersonAuth = modelUtils.getModelEntity(examPersonAuth, "examPersonAuth@auditResult");
  const load = modelUtils.getLoadingState(state, ['examPersonAuth']);
  return {
    examPersonAuthDetail,
    auditExamPersonAuth,
    ...load
  }
};

export default connect(mapStateToProps)(ExamPersonAuthDetail);
